import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { useGlobalStore } from '@/stores/global-store'
import { useRouter } from 'vue-router'
//import { debouncedPost } from '@/main'

export type ApiClient = AxiosInstance
export function createApiClient(baseURL = 'http://10.0.0.2:3000/api/v2/'): AxiosInstance {
  const GlobalStore = useGlobalStore()
  const { storeToken, storeFullname } = GlobalStore
  const cfg: AxiosRequestConfig = {
    baseURL,
    timeout: 30_000,
    headers: { 'Content-Type': 'application/json' },
  }
  const client = axios.create(cfg)
  const router = useRouter()
  client.interceptors.response.use(
    (res) => res,
    async (error) => {
      //console.log('error', error)
      const originalRequest = error.config
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        try {
          axios.defaults.headers.common.Authorization = `Bearer ${GlobalStore.refresh}`
          /*
           */
          const { data } = await axios.post(originalRequest.baseURL + '/auth/refresh')
          storeToken(data.access_token, data.refresh_token)
          originalRequest.headers.Authorization = `Bearer ${data.access_token}`
          return client(originalRequest)
        } catch (refreshError) {
          //console.log('refresh error',refreshError)
          //logging out
          storeToken('', '')
          storeFullname('')
          router.push({ name: 'login' })
          return Promise.reject(refreshError)
        }
      }
      return Promise.reject(error?.response ?? error)
    },
  )
  client.interceptors.request.use(
    (config) => {
      //console.log('request', config)
      //console.log(GlobalStore.token)
      if (GlobalStore.token) config.headers['Authorization'] = `Bearer ${GlobalStore.token}`
      return config
    },
    async (error) => {
      return Promise.reject(error)
    },
  )
  return client
}
